const VisibilityMarkerReasons = {
  DISTRICT_ADVISORY: "DISTRICT_ADVISORY",
  SCHOOL_ADVISORY: "SCHOOL_ADVISORY",
  LITE_CONTENT: "LITE_CONTENT",
  PREMIUM_CONTENT: "PREMIUM_CONTENT",
} as const;

export default VisibilityMarkerReasons;
